var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"label":_vm.$t('adminQuestion.translation') +
          _vm.languages[0] +
          ' -> ' +
          _vm.choosenLanguage}},[_c('div',{staticStyle:{"margin-left":"10px","margin-top":"5px","cursor":"pointer"},attrs:{"disabled":_vm.languages[0] === _vm.choosenLanguage},on:{"click":function($event){return _vm.translate()}}},[_c('img',{staticClass:"icon",staticStyle:{"padding":"3px"},attrs:{"src":require("@/assets/img/icons/translation-icon.png"),"alt":"icon-translation"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45748cf6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/components/ButtonTranslation.vue
// module id = null
// module chunks = 